"use client";

import * as React from "react";

import * as ToggleGroupPrimitive from "@radix-ui/react-toggle-group";

import { cn } from "@/utils";

// Simple pill-style toggle group matching the signup mock
function ToggleGroup({
  className,
  children,
  ...props
}: React.ComponentProps<typeof ToggleGroupPrimitive.Root>) {
  return (
    <ToggleGroupPrimitive.Root
      className={cn(
        "grid grid-cols-1 md:grid-cols-2 gap-3.5 w-full",
        className,
      )}
      {...props}
    >
      {children}
    </ToggleGroupPrimitive.Root>
  );
}

function ToggleGroupItem({
  className,
  children,
  ...props
}: React.ComponentProps<typeof ToggleGroupPrimitive.Item>) {
  const base =
    "max-w-[320px] bg-fog text-garnet inline-flex items-center rounded-md p-2 text-[14px] font-normal ring-1 ring-black/10";
  return (
    <ToggleGroupPrimitive.Item
      className={cn(
        base,
        " hover:data-[state=off]:bg-[#eeeaea]",
        "group/tg",
        className,
      )}
      {...props}
    >
      <div className="flex w-full items-center">
        {/* Left icon gutter (reserved width) */}
        <span className="flex w-7 justify-center">
          {Array.isArray(children)
            ? (children as Array<React.ReactNode>)[0]
            : null}
        </span>
        {/* Center label */}
        <span className="mx-auto flex-1 text-center inline-flex justify-center">
          {Array.isArray(children)
            ? (children as Array<React.ReactNode>).slice(1)
            : children}
        </span>
        {/* Right checkmark gutter (reserved width) */}
        <span className="flex w-7 justify-center">
          <img
            src="/checkmark.svg"
            width={28}
            height={28}
            alt="selected"
            aria-hidden="true"
            className="hidden group-data-[state=on]/tg:inline-block h-[28px] w-[28px]"
          />
        </span>
      </div>
    </ToggleGroupPrimitive.Item>
  );
}

export { ToggleGroup, ToggleGroupItem };
